export const Team = (props) => {
  return (
    <div id='team' className='text-center'>
      <div className='container'>
        <div className='col-md-8 col-md-offset-2 section-title'>
          <h2>Leadership Team</h2>
          <p>
            Our leadership brings together deep engineering expertise, operational excellence, and a shared passion for accelerating India's clean energy transition.
          </p>
        </div>
        <div id='row' className='team-row'>
          {props.data
            ? props.data.map((d, i) => (
                <>
                  <div key={`${d.name}-${i}`} className='col-md-3 col-sm-4 col-xs-6 team'>
                    <div className='thumbnail'>
                      <img src={d.img} alt={d.name} className='team-img' loading='lazy' />
                      <div className='caption'>
                        <h4>{d.name}</h4>
                        <p className='team-job'>{d.job}</p>
                      </div>
                    </div>
                  </div>
                  {/* Clear floats after every 2nd item on phones */}
                  {(i + 1) % 2 === 0 && (
                    <div key={`xs-clear-${i}`} className='clearfix visible-xs-block'></div>
                  )}
                  {/* Clear floats after every 3rd item on tablets */}
                  {(i + 1) % 3 === 0 && (
                    <div key={`sm-clear-${i}`} className='clearfix visible-sm-block'></div>
                  )}
                  {/* Clear floats after every 4th item on desktop */}
                  {(i + 1) % 4 === 0 && (
                    <div key={`md-clear-${i}`} className='clearfix visible-md-block visible-lg-block'></div>
                  )}
                </>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
